mutation generateMarketingPlan($input: GenerateMarketingPlanInput!) {
  result: generateMarketingPlan(input: $input) {
    status
    plan {
      id
      status
    }
  }
}
